// Shared Vietnam-time date helpers - the home screen, its schedule card and the timetable
// modal all label the same day, so the formatting lives in one place.

import { i18n } from '../i18n/index.ts';

// Spelled out to match the Figma schedule header ("Thứ Ba, 08/09/2026"); the timetable grid keeps numerals.
// Keys by getDay() order (0 = Sunday), translated at call time so the header follows the language.
const WEEKDAY_KEYS = ['home:weekday.sunday', 'home:weekday.monday', 'home:weekday.tuesday', 'home:weekday.wednesday', 'home:weekday.thursday', 'home:weekday.friday', 'home:weekday.saturday'] as const;

export function vietnamDate(): string {
  return new Date(Date.now() + 7 * 60 * 60 * 1000).toISOString().slice(0, 10);
}

/** The Vietnam calendar day of a QLT date, which arrives as VN midnight in UTC ("2026-09-27T17:00:00.000Z" is 28/09). */
export function vietnamDay(value: string): string {
  return new Date(Date.parse(value) + 7 * 60 * 60 * 1000).toISOString().slice(0, 10);
}

export function displayDate(date: string): string {
  const parts = date.split('-');
  const value = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
  return `${i18n.t(WEEKDAY_KEYS[value.getDay()])}, ${parts[2]}/${parts[1]}/${parts[0]}`;
}

export function shortDate(date: string): string {
  const parts = date.split('-');
  return `${parts[2]}/${parts[1]}`;
}

export function shiftDate(date: string, days: number): string {
  const parts = date.split('-');
  const value = new Date(Date.UTC(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]) + days));
  return value.toISOString().slice(0, 10);
}

export function weekLabel(start: string): string {
  // the grid is Mon-Sat, so the label must end on Saturday, not Sunday
  const end = shiftDate(start, 5);
  return `${shortDate(start)} - ${shortDate(end)}/${end.slice(0, 4)}`;
}
